import { FileSpreadsheet, FileText, Image, Presentation } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import { getFileKindBgClass, getFileKindCategory, getFileKindLabel } from './fileKindMeta'

const ICON_CLASS = 'mb-0.5 h-4 w-4 opacity-90'

/**
 * Same badge design as the Access Confirmations popup — solid color square, icon
 * on top, short type label below. Icon shape, color, and label all follow the file's
 * extension, and are reused everywhere a file is shown across the Resident and
 * Reimbursement modules so a given file type always looks the same.
 */
export function FileKindBadge({
  filename,
  className,
}: {
  filename: string
  className?: string
}) {
  const label = getFileKindLabel(filename)
  const bgClass = getFileKindBgClass(filename)
  const category = getFileKindCategory(filename)
  return (
    <span
      className={cn(
        'inline-flex h-10 w-9 shrink-0 flex-col items-center justify-end rounded-md pb-1 text-[9px] font-bold leading-none tracking-wide text-white',
        bgClass,
        className,
      )}
      aria-hidden="true"
    >
      {category === 'spreadsheet' ? (
        <FileSpreadsheet className={ICON_CLASS} strokeWidth={2} />
      ) : category === 'image' ? (
        <Image className={ICON_CLASS} strokeWidth={2} />
      ) : category === 'presentation' ? (
        <Presentation className={ICON_CLASS} strokeWidth={2} />
      ) : (
        <FileText className={ICON_CLASS} strokeWidth={2} />
      )}
      {label}
    </span>
  )
}
